module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Vielleicht auch was für dich"},"en":{"title":"You may be interested in"},"es":{"title":"Quizás también te guste"},"fr":{"title":"Tu aimerais peut-être aussi "},"it":{"title":"Prodotti che potrebbero interessarti"},"ja":{"title":"他のおすすめの商品"},"pt":{"title":"Você pode estar interessado(a) em"}}')
  delete Component.options._Ctor
}
